module.exports = __webpack_public_path__ + "img/ru_failure_6.2d0cc303.png";